import { BaseMapper } from '@ps/utils';
import { OperatorUserDto } from '../dtos/company.dto';
import { CompanyOperatorUser } from '../../models/company.model';

export class OperatorUserMapper extends BaseMapper<
  OperatorUserDto,
  CompanyOperatorUser
> {
  public fromDto({ id, name }: OperatorUserDto): CompanyOperatorUser {
    return { id, name };
  }
}
